var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"asc-close-button",attrs:{"text":""},on:{"click":_vm.handleClick}},[_c('asc-close-icon',{attrs:{"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }